import Base from './Base';

class Inventory extends Base {

    constructor (token) {
        super(token);
        this.endpoint = 'inventories';
    }

    getAllFromSI( client_id ) {
        return  fetch(this.getUrlEndpoint("retrieve-si/"+client_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getDamagedImages( code ) {
        return  fetch(this.getUrlEndpoint("retrieve-damaged-images/"+code),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    getImagesById(id) {
        return  fetch(this.getUrlEndpoint("getStoredImages/"+id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )
    }

    updateAll(data) {
  
        return fetch(this.getUrlEndpoint("updateAll"),{
            method: 'PATCH',
            headers: this.headers,
            body: JSON.stringify(data)
        }).then( response => response.json() )
            
    }

    getAllInventories(owner_id){
        return  fetch(this.getUrlEndpoint("retrieve-all/"+owner_id),{
            method: 'GET',
            headers: this.headers
        }).then( response => response.json() )

        
    }

    uploadInventory( data ) {
        let formData  = new FormData();
        console.log("DATA => ",Object.keys(data))
        console.log(formData.append)
        Object.keys(data).forEach(key=>{
            formData.append(`${key}`,data[key])
            console.log(`${key} : ${data[key]}`);
        });

        console.log(formData)
            return fetch(this.getUrlEndpoint("upload/inventory"),{
                method: 'POST',
                headers: this.fileHeaders,
                body: formData
            }).then( response => response.json() )
        
        
        
    }
    
}

export default Inventory;